import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import YDUI from "vue-ydui";
import "vue-ydui/dist/ydui.rem.css";
import VueWechatTitle from "vue-wechat-title";
import store from "./common/store";
import input from "./common/inputComponent";
import VueTouch from "vue-touch";
import "./common/vant";
import "./common/common";
import {Progress} from 'vant';
import {Swipe, SwipeItem} from 'vant';

Vue.use(Swipe);
Vue.use(SwipeItem);


// import Vconsole from "vconsole";
// let vConsole = new Vconsole()
// setTimeout(() => {
//   let vConsole = new Vconsole()
//   console.log(' => vConsole ', vConsole)
//   vConsole.hideSwitch()
//   Vue.prototype.$vconsole = vConsole
// }, 0)

Vue.use(Progress);

// import wx from 'weixin-js-sdk'
Vue.use(VueTouch, {name: "v-touch"});
// Vue.use(wx)
Vue.use(YDUI);
Vue.use(VueWechatTitle);
Vue.use(input);
Vue.prototype.$ajax = axios;
Vue.config.productionTip = false;
Vue.prototype.$version = "V1.1.0";
Vue.config.ignoredElements = ['wx-open-launch-weapp'];

import common from "./common/unit";

Vue.prototype.$common = common;
import "../static/css/app.css";
import "../static/css/styleRecover.css";
import "../static/css/iconfont.css";
import "../static/css/fontFamily/fontFamily.css";
import {Switch} from "vant";

Vue.use(Switch);
///request拦截器
axios.interceptors.request.use(
	config => {
		//向请求头添加token
		let type = localStorage.getItem("loginType");
		// console.log('loginType ', type)
		let token = ''
		if (type === 'BankUser') {
			token = localStorage.getItem("bankToken")
			config.headers.accountId = localStorage.getItem("accountId") || ''
			config.headers.phoneNum = localStorage.getItem("phoneNum") || ''
		} else if (type ==='borrowSmall2User') {
			token = localStorage.getItem("borrowSmall2Token")
		} else {
			token = localStorage.getItem("token")
		}

		if (token) {
			config.headers.Authorization = "Bearer " + token;
		}
		config.headers.sourceTag = "H5";
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

//response拦截器
axios.interceptors.response.use(
	response => {
		const res = response.data;
		// console.log(res)
		// if(res.data.code == '401') {
		//     router.replace({path: '/login'})
		// }
		if (res.code == "999" || res.code == "705") {
			response.data.retMsg = "系统刚才有点走神了，请稍后再试一下哦";
		}
		return response;
	},
	error => {
		//token失效返回401处理
		if (error.response && error.response.status == 401) {
			let type = localStorage.getItem("loginType");

			if (type === 'BankUser') {
				//刷新token
				localStorage.setItem("accountId", "");
				localStorage.setItem("bankToken", "");
				localStorage.setItem("jumpLogin", "");
				router.replace({path: "/loginBank"});
			} else if (type === 'borrowSmall2User') {
				//刷新token
				localStorage.setItem("borrowSmall2Token", "");
				localStorage.setItem("jumpLogin", "");
				localStorage.clear();
				router.replace({path: "/loginBorrowSmall2"});
			} else {
				//刷新token
				localStorage.setItem("dkId", '');
				localStorage.setItem("token", "");
				localStorage.setItem("jumpLogin", "");
				sessionStorage.removeItem('unicom') // 清除联通登录标记
				router.replace({path: "/login"});
			}

		}
		if (error.response) {
			// 断网时没有response数据
			return Promise.reject(error.response.data); // 返回错误信息
		} else {
			return Promise.reject({msg: "网络连接失败"}); // 返回错误信息
		}
	}
);

new Vue({
	el: "#app",
	router,
	axios,
	store,
	components: {App},
	template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js